// Everything Trainers Data - Using all coding systems combined
// COMPLETE VERSION - 6 programs per trainer
// Everything uses ALL codes: lcborsekhitfgavpqnujyz!$x&*()-+=[]{}:;|<>~w@d^_

// Zephyr Blackstone's workout programs (extracted from Android data)
const zephyrBlackstonePrograms = [
    {
        id: 'universal-movement',
        name: 'Universal Movement',
        description: 'Universal movement requires mastery across training modalities and movement patterns through balanced bodyweight, bands, and gym equipment.',
        pattern: 'w_do^!', // bodyweight: chest, shoulder, core, arm, overall
        reps: 6,
        sets: 3,
        focus: 'Universal Training'
    },
    {
        id: 'total-fitness',
        name: 'Total Fitness',
        description: 'Total fitness requires balanced development across all physical qualities: strength, endurance, mobility, stability, and power.',
        pattern: '$x+=>', // gym: chest, back, abs, leg, overall
        reps: 6,
        sets: 3,
        focus: 'Complete Fitness'
    },
    {
        id: 'body-mastery',
        name: 'Body Mastery',
        description: 'True body mastery means complete control of your physical vessel through extraordinary proprioception and movement control.',
        pattern: 'w@d_^', // bodyweight: chest, back, core, shoulder, arm
        reps: 6,
        sets: 3,
        focus: 'Body Control'
    },
    {
        id: 'complete-conditioning',
        name: 'Complete Conditioning',
        description: 'Complete conditioning develops all energy systems with balanced physical attributes through strategic protocols.',
        pattern: '~@^_!', // bodyweight: legs, back, arm, shoulder, overall
        reps: 15,
        sets: 3,
        focus: 'Total Conditioning'
    },
    {
        id: 'holistic-training',
        name: 'Holistic Training',
        description: 'Holistic training integrates mind-body awareness with balanced physical development through all modalities.',
        pattern: '_d@^~', // bodyweight: shoulder, core, back, arm, legs
        reps: 8,
        sets: 3,
        focus: 'Mind-Body Integration'
    },
    {
        id: 'movement-flow',
        name: 'Movement Flow',
        description: 'Movement flow transcends individual exercises to create seamless physical expression through equipment modalities.',
        pattern: 'w@_^d', // bodyweight: chest, back, shoulder, arm, core
        reps: 5,
        sets: 3,
        focus: 'Flow Mastery'
    }
];

// Atlas Kaine's workout programs (extracted from Android data)
const atlasKainePrograms = [
    {
        id: 'complete-mastery',
        name: 'Complete Mastery',
        description: 'Complete mastery requires systematic development across all training modalities through gym, bodyweight, and band work.',
        pattern: '$x&*+=', // gym: chest, back, shoulder, arm, abs, leg
        reps: 6,
        sets: 3,
        focus: 'Complete Development'
    },
    {
        id: 'ultimate-training',
        name: 'Ultimate Training',
        description: 'Ultimate training integrates the best elements from all training methodologies for complete physical development.',
        pattern: '$&x*+>', // gym: chest, shoulder, back, arm, abs, overall
        reps: 6,
        sets: 3,
        focus: 'Ultimate Performance'
    },
    {
        id: 'hybrid-workout',
        name: 'Hybrid Workout',
        description: 'Hybrid training combines multiple modalities within the same workout for seamless transitions and adaptability.',
        pattern: '$w+^', // gym chest, bodyweight chest, gym abs, bodyweight arm
        reps: 6,
        sets: 3,
        focus: 'Hybrid Integration'
    },
    {
        id: 'full-system',
        name: 'Full System',
        description: 'A full system approach addresses all physical qualities systematically through comprehensive training blocks.',
        pattern: '$x&*+>', // gym: chest, back, shoulder, arm, abs, overall
        reps: 7,
        sets: 3,
        focus: 'System Development'
    },
    {
        id: 'multi-discipline',
        name: 'Multi-Discipline',
        description: 'Multi-discipline training integrates specialized approaches from powerlifting, bodybuilding, and calisthenics.',
        pattern: '$x&+=', // gym: chest, back, shoulder, abs, leg
        reps: 7,
        sets: 3,
        focus: 'Multi-Discipline'
    },
    {
        id: 'comprehensive-strength',
        name: 'Comprehensive Strength',
        description: 'Comprehensive strength addresses all strength qualities across modalities with no weaknesses.',
        pattern: '$x&*=>', // gym: chest, back, shoulder, arm, leg, overall
        reps: 7,
        sets: 3,
        focus: 'Complete Strength'
    }
];

// Orion Phoenix's workout programs (extracted from Android data)
const orionPhoenixPrograms = [
    {
        id: 'total-transformation',
        name: 'Total Transformation',
        description: 'Total transformation requires systematic changes to both physical structure and metabolic function.',
        pattern: '$x&*+=', // gym: chest, back, shoulder, arm, abs, leg
        reps: 8,
        sets: 3,
        focus: 'Complete Transformation'
    },
    {
        id: 'rebirth-protocol',
        name: 'Rebirth Protocol',
        description: 'The rebirth protocol systematically removes old movement patterns while building new ones.',
        pattern: 'w@d^_~', // bodyweight: chest, back, core, arm, shoulder, legs
        reps: 10,
        sets: 3,
        focus: 'Pattern Renewal'
    },
    {
        id: 'rising-force',
        name: 'Rising Force',
        description: 'Rising force development creates progressive physical ascension through strategic progression.',
        pattern: '$x&*>', // gym: chest, back, shoulder, arm, overall
        reps: 8,
        sets: 3,
        focus: 'Ascending Power'
    },
    {
        id: 'complete-evolution',
        name: 'Complete Evolution',
        description: 'Complete evolution addresses every aspect of physical development systematically.',
        pattern: '$&x+*>', // gym: chest, shoulder, back, abs, arm, overall
        reps: 10,
        sets: 3,
        focus: 'Physical Evolution'
    },
    {
        id: 'ascended-training',
        name: 'Ascended Training',
        description: 'Ascended training elevates physical capabilities beyond conventional limits.',
        pattern: '$&x*>', // gym: chest, shoulder, back, arm, overall
        reps: 8,
        sets: 3,
        focus: 'Transcendent Training'
    },
    {
        id: 'fusion-method',
        name: 'Fusion Method',
        description: 'The fusion method integrates conflicting training approaches into a harmonious whole.',
        pattern: '$xw@^', // gym chest/back, bodyweight chest/back/arm
        reps: 8,
        sets: 3,
        focus: 'Fusion Training'
    }
];

// Vortex Shadowstone's workout programs (extracted from Android data)
const vortexShadowstonePrograms = [
    {
        id: 'dimensional-training',
        name: 'Dimensional Training',
        description: 'Dimensional training transcends traditional movement planes to develop complete spatial mastery.',
        pattern: 'w@^_~d', // bodyweight: chest, back, arm, shoulder, legs, core
        reps: 8,
        sets: 3,
        focus: 'Dimensional Movement'
    },
    {
        id: 'shadow-force',
        name: 'Shadow Force',
        description: 'Shadow force training develops the ability to harness power that exists between dimensions.',
        pattern: '$&*xw@', // gym shoulder/arm/back, bodyweight chest/back
        reps: 6,
        sets: 3,
        focus: 'Shadow Power'
    },
    {
        id: 'vortex-method',
        name: 'Vortex Method',
        description: 'The vortex method harnesses spiraling energy patterns for extraordinary force development.',
        pattern: 'x@&+;z', // gym/bodyweight: back, back, shoulder, abs, obliques, oblique
        reps: 8,
        sets: 3,
        focus: 'Vortex Energy'
    },
    {
        id: 'multi-plane-power',
        name: 'Multi-Plane Power',
        description: 'Multi-plane power development creates force expression across dimensional boundaries.',
        pattern: '$&*=', // gym: chest, shoulder, arm, leg
        reps: 6,
        sets: 3,
        focus: 'Multi-Planar Power'
    },
    {
        id: 'energy-system',
        name: 'Energy System',
        description: 'Energy system development optimizes the bodys capacity to generate and sustain force.',
        pattern: '$x&+*', // gym: chest, back, shoulder, abs, arm
        reps: 5,
        sets: 3,
        focus: 'Energy Mastery'
    },
    {
        id: 'metaphysical-strength',
        name: 'Metaphysical Strength',
        description: 'Metaphysical strength transcends physical limitations through mind-body integration.',
        pattern: 'w@^_~d!', // bodyweight: chest, back, arm, shoulder, legs, core, overall
        reps: 8,
        sets: 3,
        focus: 'Transcendent Strength'
    }
];

// Talon Wolfe's workout programs (extracted from Android data)
const talonWolfePrograms = [
    {
        id: 'hybrid-conditioning',
        name: 'Hybrid Conditioning',
        description: 'Hybrid conditioning blends multiple training modalities to create a complete physical predator.',
        pattern: 'w@d^_~', // bodyweight: chest, back, core, arm, shoulder, legs
        reps: 10,
        sets: 3,
        focus: 'Predator Conditioning'
    },
    {
        id: 'predator-training',
        name: 'Predator Training',
        description: 'Predator training develops the specific movement qualities of natures perfect hunters.',
        pattern: 'w~_@d^', // bodyweight: chest, legs, shoulder, back, core, arm
        reps: 10,
        sets: 3,
        focus: 'Apex Movement'
    },
    {
        id: 'primal-power',
        name: 'Primal Power',
        description: 'Primal power taps into the raw strength and explosive capacity dormant within our ancestral DNA.',
        pattern: 'w@~^d_', // bodyweight: chest, back, legs, arm, core, shoulder
        reps: 8,
        sets: 3,
        focus: 'Primal Strength'
    },
    {
        id: 'alpha-strength',
        name: 'Alpha Strength',
        description: 'Alpha strength represents the apex of physical power and dominance in any environment.',
        pattern: '$&x*+', // gym: chest, shoulder, back, arm, abs
        reps: 6,
        sets: 3,
        focus: 'Dominant Power'
    },
    {
        id: 'hunter-method',
        name: 'Hunter Method',
        description: 'The hunter method creates the complete physical and mental toolkit of a master predator.',
        pattern: '~w@^_', // bodyweight: legs, chest, back, arm, shoulder
        reps: 8,
        sets: 3,
        focus: 'Hunter Skills'
    },
    {
        id: 'instinct-training',
        name: 'Instinct Training',
        description: 'Instinct training bypasses conscious thought to access the primal movement intelligence within our DNA.',
        pattern: 'w@~^_d', // bodyweight: chest, back, legs, arm, shoulder, core
        reps: 10,
        sets: 3,
        focus: 'Instinctive Movement'
    }
];

// Nova Steelheart's workout programs (extracted from Android data)
const novaSteelheartPrograms = [
    {
        id: 'cosmic-power',
        name: 'Cosmic Power',
        description: 'Cosmic power integration taps into the universal energy that permeates all things.',
        pattern: 'w@d^_~', // bodyweight: chest, back, core, arm, shoulder, legs
        reps: 8,
        sets: 3,
        focus: 'Cosmic Integration'
    },
    {
        id: 'stellar-strength',
        name: 'Stellar Strength',
        description: 'Stellar strength harnesses the same fusion energy that powers the stars.',
        pattern: '$&x*+>', // gym: chest, shoulder, back, arm, abs, overall
        reps: 6,
        sets: 3,
        focus: 'Stellar Power'
    },
    {
        id: 'fusion-training',
        name: 'Fusion Training',
        description: 'Fusion training combines multiple energy sources to create extraordinary power output.',
        pattern: '$w@+', // gym chest, bodyweight chest/back, gym abs
        reps: 8,
        sets: 3,
        focus: 'Energy Fusion'
    },
    {
        id: 'gravitational-force',
        name: 'Gravitational Force',
        description: 'Gravitational force training develops the ability to generate unstoppable pulling power.',
        pattern: 'x&*+', // gym: back, shoulder, arm, abs
        reps: 6,
        sets: 3,
        focus: 'Gravitational Power'
    },
    {
        id: 'interstellar-method',
        name: 'Interstellar Method',
        description: 'The interstellar method creates connections between distant energy centers for complete integration.',
        pattern: 'w@^$&', // bodyweight chest/back/arm, gym chest/shoulder
        reps: 8,
        sets: 3,
        focus: 'Interstellar Connection'
    },
    {
        id: 'supernova-intensity',
        name: 'Supernova Intensity',
        description: 'Supernova intensity creates explosive energy output that radiates through all movement.',
        pattern: '$&x*>', // gym: chest, shoulder, back, arm, overall
        reps: 5,
        sets: 3,
        focus: 'Explosive Intensity'
    }
];

// Everything trainers data structure
const everythingTrainersData = {
    'zephyr-blackstone': {
        id: 'zephyr-blackstone',
        name: 'Zephyr Blackstone',
        specialization: 'Complete Fitness Mastery',
        image: '/assets/images/v64.jpg',
        experience: '20+ Years',
        category: 'everything',
        intro: `Zephyr Blackstone developed his comprehensive expertise through decades of mastering every fitness discipline. With his lean, powerful build, intense focus, and holistic approach, Zephyr specializes in complete fitness mastery that integrates all training modalities. After achieving expert level in strength training, endurance sports, martial arts, and movement disciplines, he created integrated systems that develop total physical capability. "True fitness isn't specialization—it's the seamless integration of all physical qualities," is his training philosophy. Zephyr's comprehensive background creates transformational programs that develop complete athletes rather than one-dimensional specialists.`,
        programs: zephyrBlackstonePrograms
    },
    'atlas-kaine': {
        id: 'atlas-kaine',
        name: 'Atlas Kaine',
        specialization: 'Strength & Endurance Fusion',
        image: '/assets/images/v68.jpg',
        experience: '18+ Years',
        category: 'everything',
        intro: `Atlas Kaine forged his powerful physique through competitive strength sports and endurance athletics. With his muscular build, determined expression, and balanced approach, Atlas specializes in fusing strength and endurance training. After competing in both powerlifting and endurance events, he developed unique methodologies that build both power and stamina simultaneously. "Strength without endurance is fleeting, endurance without strength is weak—fusion creates ultimate capability," is his core philosophy. Atlas's dual-sport background creates powerful programs that develop both explosive power and sustained performance capacity.`,
        programs: atlasKainePrograms
    },
    'orion-phoenix': {
        id: 'orion-phoenix',
        name: 'Orion Phoenix',
        specialization: 'Movement & Mobility Specialist',
        image: '/assets/images/v71.jpg',
        experience: '15+ Years',
        category: 'everything',
        intro: `Orion Phoenix developed his movement expertise through martial arts, dance, and rehabilitative training. With his athletic build, fluid movement, and precision-focused approach, Orion specializes in movement quality and mobility integration. After mastering multiple movement disciplines and working in rehabilitation, he created systems that emphasize movement excellence alongside strength development. "Perfect movement is the foundation of all physical achievement—master the patterns, master your body," is his guiding principle. Orion's diverse movement background creates comprehensive programs that develop both exceptional movement quality and functional strength.`,
        programs: orionPhoenixPrograms
    },
    'vortex-shadowstone': {
        id: 'vortex-shadowstone',
        name: 'Vortex Shadowstone',
        specialization: 'High-Intensity Integration Specialist',
        image: '/assets/images/v73.jpg',
        experience: '16+ Years',
        category: 'everything',
        intro: `Vortex Shadowstone built his intense physique through high-intensity training and competitive fitness. With his lean, defined build, fierce intensity, and efficiency-focused approach, Vortex specializes in high-intensity programs that integrate all training modalities. After dominating in multiple competitive fitness disciplines, he perfected methods that maximize results through intelligent intensity application. "Intensity without intelligence is chaos—strategic intensity creates transformation," is his training philosophy. Vortex's competitive background creates powerful programs that deliver maximum results in minimum time through precise intensity management.`,
        programs: vortexShadowstonePrograms
    },
    'talon-wolfe': {
        id: 'talon-wolfe',
        name: 'Talon Wolfe',
        specialization: 'Combat Conditioning Specialist',
        image: '/assets/images/v74.jpg',
        experience: '17+ Years',
        category: 'everything',
        intro: `Talon Wolfe forged his warrior physique through military service and combat sports training. With his powerful build, intense gaze, and tactical approach, Talon specializes in combat conditioning that integrates strength, endurance, and mental toughness. After serving in elite military units and competing in combat sports, he developed comprehensive training systems for tactical fitness. "Combat conditioning isn't just physical—it's about building unbreakable warriors," is his core philosophy. Talon's military and combat sports background creates demanding programs that develop both physical capability and mental resilience.`,
        programs: talonWolfePrograms
    },
    'nova-steelheart': {
        id: 'nova-steelheart',
        name: 'Nova Steelheart',
        specialization: 'Holistic Fitness Specialist',
        image: '/assets/images/v84.jpg',
        experience: '14+ Years',
        category: 'everything',
        intro: `Nova Steelheart developed her balanced physique through holistic fitness and wellness coaching. With her strong, feminine build, compassionate approach, and wellness-focused methodology, Nova specializes in holistic fitness that integrates physical training with mental and emotional wellness. After working in both high-performance athletics and wellness coaching, she created balanced approaches to complete fitness development. "True fitness encompasses body, mind, and spirit—balance creates lasting transformation," is her guiding philosophy. Nova's holistic background creates comprehensive programs that develop complete wellness alongside impressive physical capabilities.`,
        programs: novaSteelheartPrograms
    }
};

// Export functions
export const getEverythingTrainerData = (trainerId) => {
    return everythingTrainersData[trainerId] || null;
};

export const getAllEverythingTrainers = () => {
    return Object.values(everythingTrainersData);
};

export default everythingTrainersData;